import { Injector, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthService } from '@core/auth/auth.service';

/**
 * Runs on app startup. If a Firebase session is already active (page refresh,
 * returning user), fetches the backend profile so that `currentUserRole` and
 * `profileReady` are populated before any route guard runs.
 *
 * For unauthenticated users it resolves immediately without any network call.
 */
export function initUserProfile(): Promise<void> {
  const auth = inject(AuthService);
  const injector = inject(Injector);

  return new Promise((resolve) => {
    toObservable(auth.ready, { injector })
      .pipe(
        filter((ready) => ready),
        take(1),
        switchMap(() => {
          if (!auth.isAuthenticated()) return of(null);
          auth.loadUserProfile();
          return toObservable(auth.profileReady, { injector }).pipe(
            filter((ready) => ready),
            take(1)
          );
        })
      )
      .subscribe(() => resolve());
  });
}
